document.addEventListener('DOMContentLoaded', () => {
	const wrappers = document.querySelectorAll('.tabs-wrapper');
        if (wrappers.length > 0) {
            wrappers.forEach(function (wrapper) {
                const tabs = wrapper.querySelectorAll('.tab');
                const tabItems = wrapper.querySelectorAll('.tab-item');
                tabItems.forEach(function (item, index) {
                    if (index === 0) {
                        item.style.display = "block";
                        setTimeout(function () {
                            if (item.classList.contains('preload')) item.classList.remove('preload');
                        }, 500);
                    } else {
                        item.style.display = "none";
                    }
                });

                tabs.forEach(function (tab, index) {
                    tab.addEventListener('click', function (e) {
                        e.preventDefault();
                        tabs.forEach(tab => tab.classList.remove('active'));
                        tab.classList.add('active');
                        tabItems.forEach(item => (item.style.display = "none"));
                        if (tabItems[index]) {
                            tabItems[index].style.display = "block";
                            tabItems[index].classList.add('preload');
                            setTimeout(function () {
                                tabItems[index].classList.remove('preload');
                            }, 500);
                        }
                    });
                    if (index === 0) {
                        tab.classList.add('active');
                    }
                });
            });
        }

        // Video section play button
        document.addEventListener('click', function(e) {
        const btn = e.target.closest('.video-play-button');
        if (!btn) return;

        const wrapper = btn.closest('.video-wrapper');
        const video = wrapper.querySelector('.video-element');
        const poster = wrapper.querySelector('.video-poster');

        poster.style.display = 'none';
        video.style.display = 'block';
        video.play();
        });
});